import type { RiskTier } from '../types/index.js';
import type { DriftReport, LiveState, ProvisionSnapshot } from './types.js';
import { compareToolPolicy, compareChannelConfig, compareSandboxMode, compareFileHashes } from './comparators.js';

export function detectDrift(
  snapshot: ProvisionSnapshot,
  liveState: LiveState,
  agentId: string,
  codeName: string,
  riskTier: RiskTier,
): DriftReport {
  const findings = [
    ...compareToolPolicy(
      { allow: snapshot.toolAllow, deny: snapshot.toolDeny },
      {
        allow: (liveState.frameworkConfig?.['toolAllow'] as string[] | undefined) ?? snapshot.toolAllow,
        deny: (liveState.frameworkConfig?.['toolDeny'] as string[] | undefined) ?? snapshot.toolDeny,
      },
    ),
    ...compareChannelConfig(
      snapshot.channelsConfig,
      (liveState.frameworkConfig?.['channels'] as Record<string, unknown> | undefined) ?? {},
    ),
    ...compareSandboxMode(
      riskTier,
      snapshot.sandboxMode,
      (liveState.frameworkConfig?.['sandboxMode'] as string | undefined) ?? snapshot.sandboxMode,
    ),
    ...compareFileHashes(
      { charterHash: snapshot.charterHash, toolsHash: snapshot.toolsHash },
      { charterHash: liveState.charterHash, toolsHash: liveState.toolsHash },
    ),
  ];

  const criticalCount = findings.filter((f) => f.severity === 'critical').length;
  const warningCount = findings.filter((f) => f.severity === 'warning').length;

  return {
    agentId,
    codeName,
    checkedAt: new Date(),
    findings,
    hasDrift: findings.length > 0,
    criticalCount,
    warningCount,
  };
}
